/* eslint-disable no-new-object */

import * as Constants from "utils/Constants";

import { EMAIL_DESIGNER } from "redux/constants/action-types";
import HelperFunctions from "utils/HelperFunctions";
import Moment from 'moment';
import authService from "../../../components/api-authorization/AuthorizeService";
import axios from "axios";
import { downloadFileV2 } from "redux/actions/Common/Common";

export function BEEAuth(clientId, isBEEPageAuth = false) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/Auth?clientId=${clientId}&isBeePageAuth=${isBEEPageAuth}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.BEE_AUTH,
        payload: JSON.parse(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAbandonCartSpecialLinks(
  clientId,
  showAll = false,
  status = "Published"
) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "ESP/Design/GetAbandonCartSpecialLinks?clientId=" +
        clientId;

      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.ABANDON_CART_SPECIAL_LINKS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSurveySpecialLinks(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        (import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API) +
        "ESP/Design/GetSurveySpecialLinks?clientId=" +
        clientId;

      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.SURVEY_SPECIAL_LINKS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function sendAIGenerateDesignRequest(clientId, threadId, prompt, currentDesignJson = "", designId = 0, planOnly = false, signal = undefined, mcpTemplateId = "", isBuild = false) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_START,
      });

        const URL = Constants.VNEXT_BASE_URL + "ESP/Design/SendAIGenerateDesignRequest";

        const payload = {
          threadId: threadId,
          requestText: prompt,
          currentDesignJson: currentDesignJson || "",
          designId: designId || 0,
          planOnly: planOnly || false,
          mcpTemplateId: mcpTemplateId || "", // live co-edit: edit the editor-joined MCP session
          isBuild: isBuild || false // true = from-scratch build → backend uses a Code Mode BUILD prompt
        };

        dispatch({
          type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_STAGE_2,
        });

        const response = await axios.post(URL, JSON.stringify(payload), {
          headers: {
            'Content-Type': 'application/json',
          },
          params: {
            clientId: clientId
          },
          signal, // allows the caller to abort an in-flight generation
        });

        dispatch({
          type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_SUCCESS,
          payload: response.data,
        });

        return response.data;
    } catch (error) {
      console.log("error", error.response);
      dispatch({
        type: EMAIL_DESIGNER.AI_GENERATE_DESIGN_REQUEST_ERROR,
        payload: error.response?.data || error.message,
      });
      throw error;
    }
  };
}

// Fetch a design's saved AI conversation (thread id + messages) so the docked panel can resume it on load.
export function getAiConversation(clientId, designId) {
  return async function () {
    try {
      if (!designId) return { threadId: "", messages: [] };
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetAiConversation`;
      const response = await axios.get(URL, { params: { clientId, designId } });
      const data = response.data || {};
      return { threadId: data.threadId || "", messages: data.messages || [] };
    } catch (error) {
      console.log("getAiConversation error", error?.response);
      return { threadId: "", messages: [] };
    }
  };
}

// How complete the client's Brand-tab setup is (0..6 dimensions). Drives the AI panel's setup nudges.
export function getBrandReadiness(clientId) {
  return async function () {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetBrandReadiness`;
      const response = await axios.get(URL, { params: { clientId } });
      const data = response.data || null;
      return data && data.success ? data : null;
    } catch (error) {
      console.log("getBrandReadiness error", error?.response);
      return null;
    }
  };
}

// Live output-token progress for an in-flight AI generation (drives the panel's progress bar).
export function getAiGenerationProgress(clientId, designId) {
  return async function () {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetAiGenerationProgress`;
      const response = await axios.get(URL, { params: { clientId, designId: designId || 0 } });
      const data = response.data || null;
      return data && data.success ? data : null;
    } catch (error) {
      return null;
    }
  };
}

// Drop a design's saved AI conversation so the next message starts a fresh thread.
export function clearAiConversation(clientId, designId) {
  return async function () {
    try {
      if (!designId) return { success: true };
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Design/ClearAiConversation`;
      const response = await axios.post(URL, null, { params: { clientId, designId } });
      return response.data || { success: true };
    } catch (error) {
      console.log("clearAiConversation error", error?.response);
      return { success: false };
    }
  };
}

// Save a confirmed guess/fact into the client's durable AI memory.
export function saveAiMemoryItem(clientId, text, kind = 'fact') {
  return async function () {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Design/SaveAiMemoryItem`;
      const response = await axios.post(URL, { text, kind }, { params: { clientId } });
      return response.data || { success: true };
    } catch (error) {
      console.log("saveAiMemoryItem error", error?.response);
      return { success: false };
    }
  };
}

export function submitAIFeedback(clientId, messageId, rating, feedback = '', remember = true) {

  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Design/SubmitAIFeedback?clientId=${clientId}`;


      const response = await axios.post(URL, {
        messageId,
        rating,
        feedback,
        remember
      });


      if (response.data.success) {
        dispatch({
          type: EMAIL_DESIGNER.AI_FEEDBACK_SUBMIT_SUCCESS,
          payload: { messageId, rating, feedback }
        });
        return { success: true };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.AI_FEEDBACK_SUBMIT_ERROR,
          payload: response.data.error
        });
        return { success: false, error: response.data.error };
      }
    } catch (error) {
      dispatch({
        type: EMAIL_DESIGNER.AI_FEEDBACK_SUBMIT_ERROR,
        payload: error.response?.data || error.message,
      });
      return { success: false, error: error.message };
    }
  };
}

export function UpdateBeeUnsavedChanges(status = false) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.BEE_UNSAVED_CHANGES,
        payload: status,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function UpdateIsTriggeredSend(status = false) {
  localStorage.setItem('localStorageTriggerdSendValue', status);
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.UPDATE_IS_TRIGGERED_SEND_VALUE,
        payload: status,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function UpdateTrackingParameters(trackingParameters) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.HANDLE_TRACKING_PARAMETERS,
        payload: trackingParameters,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function UpdateTrackingParametersSelectedItem(trackingParametersSelectedItem) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.HANDLE_TRACKING_PARAMETERS_SELECTED_ITEM,
        payload: trackingParametersSelectedItem,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function RemoveBEEAuth() {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.REMOVE_BEE_AUTH,
        payload: JSON.parse(null),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function onSaveTemplate(param, clientId, isStock, isShared = false) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL + "ESP/Template/Save?clientId=" + clientId;
      if (isStock) {
        URL += `&isStock=${isStock}`;
      }
      if (isShared) {
        URL += `&isShared=${isShared}`;
      }
      const response = await axios({
        method: "post",
        url: URL,
        data: param,
      });

      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_TEMPLATE,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

// const _sleep = (ms) => {
//   return new Promise((resolve) => setTimeout(resolve, ms));
// };
export const saveEmailDesign =
  (clientId, templateId, params, isFromScratch, isNewVersion, isBeaconCall) =>
    async (dispatch) => {
      let response = {};
      if (isBeaconCall) {
        console.log("isBeamCalled: ", isBeaconCall);
        response = await onSaveDesignBeacon(
          clientId,
          templateId ? templateId : 0,
          params,
          isNewVersion
        );
      } else {
        if (isFromScratch) {
          // TODO: Need to propogate changes in redux
          //       so that newer version can be saved on subsequent requests
          response = dispatch(onSaveFromScratch(clientId, params));
        } else {
          response = dispatch(
            onSaveDesign(params, clientId, templateId, false, false, isNewVersion)
          );
        }
      }
      return response;
    };
export const onSaveFromScratchBeacon = (clientId, params) => {
  //TODO: Implement Beacon Call for onSaveFromScratch
  navigator.sendBeacon(
    `http://localhost:3001/?text=BrowserClosed`,
    JSON.stringify(params)
  );
  return { success: true };
};

export const onSaveDesignBeacon = async (
  clientId,
  templateId,
  params,
  isNewVersion = false
) => {
  //TODO: Implement Beacon Call for onSaveDesign: Done
  //TODO: Need to check if it will work with token: Done
  const token = await authService.getAccessToken();
  fetch(
    Constants.VNEXT_BASE_URL +
    "ESP/Design/Save?clientId=" +
    clientId +
    "&templateId=" +
    templateId +
    "&isNewVersion=" +
    isNewVersion,
    {
      keepalive: true,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(params),
    }
  );
  return { success: true };
};

export function onSaveFromScratch(param, clientId) {
  return async function (dispatch) {
    try {
      var response;

      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/SaveFromScratch";

      response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
        },
      });
      //TODO: Get newly saved id back from API and save in current design
      //      So that it can determine that its not a new design on save.
      const payload = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_DESIGN,
        payload,
      });
      return payload;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function onSaveDesign(
  param,
  clientId,
  templateId,
  isStock = false,
  isShared = false,
  isUpdate = false
) {
  return async function (dispatch) {
    try {
      var response;
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Save";
      //TODO: Update API Call to get isNewVersion and handle it properly.
      response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
          templateId: templateId,
          isStock: isStock,
          isShared: isShared,
          isUpdate: isUpdate,
        },
      });
      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_DESIGN,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function GetSeedLists(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetSeedListWithCount?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.SEED_LIST,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetDesignUpdateInterval(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetEmailDesign?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_UPDATE_INTERVAL,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetTestEmailLists(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetTestEmailLists?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.TEST_EMAIL_LIST,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function sendTestEmail(clientId, param) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SendTestEmail";

      const response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
        },
      });

      const data = response.data;
      dispatch({
        type: EMAIL_DESIGNER.SEND_TEST_EMAIL,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllTemplates(clientId, folderId, parentClientId, isStock, isShared, searchText = "") {
  return async function (dispatch) {
    try {
        if (clientId == 0) { return;}
        let URL = `${Constants.VNEXT_BASE_URL}ESP/Template/GetAll?clientId=${clientId}&isStock=${isStock}&isShared=${isShared}`;
      if (folderId) {
        URL += `&folderId=${folderId}`;
      }
      if (parentClientId) {
        URL += `&parentClientId=${parentClientId}`;
      }
      if (searchText) {
        URL += `&searchText=${encodeURIComponent(searchText)}`;
      }

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_TEMPLATES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetStockFolders(clientId) {
  return async function (dispatch) {
      try {
          if (clientId == 0) { return; }
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Template/GetStockFolders?clientId=${clientId}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_STOCK_FOLDERS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetShareFolders(clientId) {
  return async function (dispatch) {
      try {
          if (clientId == 0) { return; }
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Template/GetShareFolders?ClientId=${clientId}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_SHARE_FOLDERS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getTemplateByID(clientId, templateId) {
  return async function (dispatch) {
      try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Template/Get?clientId=" +
        clientId +
        "&templateId=" +
        templateId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_TEMPLATE_BY_ID,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getTemplateDesignViewMode(clientId) {
  return async function (dispatch) {
      try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Template/GetTemplateDesignViewMode?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_TEMPLATE_DESIGN_VIEW_MODE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllDesigns(clientId, folderId) {
  return async function (dispatch) {
      try {
      var _folderId = folderId ? folderId : 0;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetLibraryContents?clientId=" +
        clientId +
        "&folderId=" +
        _folderId;

      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_DESIGNS,
        payload: HelperFunctions.responseHandlerVNext(response.data), //HelperFunctions.responseHandler(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDesignByID(clientId, designId, isStock, isShared = false, config = {}) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/Get?clientId=${clientId}&designId=${designId}`;
      if (isStock) {
        URL += `&isStock=${isStock}`;
      }
      if (isShared) {
        URL += `&isShared=${isShared}`;
      }
      const response = await axios.get(URL, config);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      if (data) {
        data.createdDate = Moment(data.createdDate, 'YYYY-MM-DD HH:mm').toDate();
        data.endDate = Moment(data.endDate, 'YYYY-MM-DD HH:mm').toDate();
        data.lastSentDate = Moment(data.lastSentDate, 'YYYY-MM-DD HH:mm').toDate();
        data.modifiedDate = Moment(data.modifiedDate, 'YYYY-MM-DD HH:mm').toDate();
        data.startDate = Moment(data.startDate, 'YYYY-MM-DD HH:mm').toDate();
      }
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_BY_ID,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function emptyDesignData(payload) {
  return {
    type: EMAIL_DESIGNER.GET_DESIGN_BY_ID,
    payload,
  };
}

export function RemoveEmailDesign(designId, clientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Delete";

      const response = await axios.delete(URL, {
        params: {
          clientId: clientId,
          designId: designId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_DESIGN,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ConvertHtmlToJson(clientId, designId, html) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Design/GetHtmlImport?clientId=" + clientId;
    

      const response = await axios.post(URL, {
        clientId: clientId,
        designId: designId,
        html: html,
      });

      return response.data;
    } catch (error) {
      console.error("error", error);
    }
  };
}

export function SendCommentNotifiction(clientId, designId, notificationType, message, notifySingleUserId,
                                       mentions, commentUrl, emailName, commentAuthorUsername,
                                      clientName,threadContributors = []) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Design/SendCommentNotifiction?clientId=" + clientId + "&designId=" + (designId || 0);
      console.log("notifySingleUserId", notifySingleUserId);
      const response = await axios.post(URL, {
        NotificationType: notificationType,
        Message: message,
        NotifySingleUserId: notifySingleUserId,
        Mentions: mentions,
        CommentUrl: commentUrl,
        EmailName: emailName,
        CommentAuthorUsername: commentAuthorUsername,
        ClientName: clientName,
        ThreadContributors: threadContributors
      }, { suppressToast: true });

      return response.data;
    } catch (error) {
      console.error("error", error);
    }
  };
}

export function UpdateCommentHasStatus(clientId, designId, hasComments) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Design/UpdateCommentHasStatus?clientId=" + clientId + "&designId=" + designId + "&hasComments=" + hasComments;
      await axios.post(URL, null, { suppressToast: true });
    } catch (error) {
      console.error("[UpdateCommentHasStatus] error", error);
    }
  };
}

export function GetHTMLImportCreditLimit(clientId) {
  return async function (dispatch) {
    try {
      
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetHTMLImportCreditLimit?clientId=${clientId}`;

      const response = await axios.get(URL);

      return response.data;

    } catch (error) {
      console.error("error", error);
    }
  };
}

export function GetWebHookData(clientId, webHookConfigId) {

  return async function (dispatch) {
    try {

      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetWebhookData?clientId=${clientId}&webhookConfigId=${webHookConfigId}`;

      const response = await axios.get(URL);

      return response.data;

    } catch (error) {
      console.log("error", error);
    }
  };
}

// Triggered Emails browser feed (Task 73624). Returns the ResponseViewModel; rows are in .content.
// Every design wired to a webhook email trigger, ungated. Distinct from getConfirmationDesigns, which
// narrows the same set by the client's Advanced payload keys: that gate suits a filter dropdown, but the
// live sending strip needs "is a triggered email", which is a fact, rather than "is a confirmation", which
// the data cannot tell us (Feature 75030).
export function getTriggeredDesigns(clientId) {
  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/GetTriggeredDesigns?clientId=${clientId}`;
      const response = await axios.get(URL, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getTriggeredResendPreview(clientId, webhookDataId, webhookConfigId) {
  return async function () {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/GetTriggeredResendPreview`
        + `?clientId=${clientId}&webhookDataId=${webhookDataId}&webhookConfigId=${webhookConfigId}`;
      // suppressToast: the modal reports its own failure and still lets the user resend without a preview,
      // so a generic error toast over the top would overstate what went wrong.
      const response = await axios.get(URL, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getTriggeredMappingPreview(clientId, designId, payload, payloadMapping) {
  return async function () {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/GetTriggeredMappingPreview?clientId=${clientId}`;
      // POST because a real payload is far larger than a query string allows. suppressToast because the
      // mapping workspace works without the preview and reports a failed render in the preview pane
      // itself; a generic toast would say the mapping had failed when only the picture of it had.
      const response = await axios.post(
        URL, { designId, payload, payloadMapping }, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getTriggeredDeliveryStatus(clientId, designId, emailAddresses) {
  return async function () {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/GetTriggeredDeliveryStatus?clientId=${clientId}`;
      // POST because the addresses being asked about are both numerous and personal, and suppressToast
      // because this only decorates a page that works fine without it: a reporting outage must not throw a
      // generic error toast over a search that succeeded.
      const response = await axios.post(URL, { designId, emailAddresses }, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getTriggeredEmailHistory(clientId, term = '', designId = 0, take = 100) {
  return async function (dispatch) {
    try {
      const params = new URLSearchParams({ clientId, term: term || '', designId: designId || 0, take });
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/GetTriggeredEmailHistory?${params.toString()}`;
      const response = await axios.get(URL, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

// Advanced settings — client-level Triggered Emails settings (qualifying payload keys + group-by key).
export function getTriggeredEmailSettings(clientId) {
  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/GetTriggeredEmailSettings?clientId=${clientId}`;
      const response = await axios.get(URL, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function saveTriggeredEmailSettings(clientId, settings) {
  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/SaveTriggeredEmailSettings?clientId=${clientId}`;
      const response = await axios.post(URL, settings || {}, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

// Triggered Emails dropdown — the designs that have produced reservation-bearing payloads.
export function getConfirmationDesigns(clientId) {
  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Email/GetConfirmationDesigns?clientId=${clientId}`;
      const response = await axios.get(URL, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ShareTemplate(templateId, clientId, parentClientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Template/CreateSharedTemplate";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          parentClientId: parentClientId,
          templateId: templateId
        },
      });

      // dispatch({
      //   type: EMAIL_DESIGNER.SHARE,
      //   payload: HelperFunctions.responseHandlerVNext(response.data),
      // });

      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DisableTemplate(templateId, clientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Template/Delete";

      const response = await axios.delete(URL, {
        params: {
          clientId: clientId,
          templateId: templateId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_TEMPLATE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function GetFolders(clientId, folderId, searchText = "", status = "") {
  return async function (dispatch) {
    try {
      var _folderId = folderId ? folderId : 0;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetLibraryContents?clientId=" +
        clientId +
        "&folderId=" +
        _folderId +
        "&searchText=" +
        encodeURIComponent(searchText) +
        "&status=" +
        status;

      const response = await axios.get(URL);

      var helper = HelperFunctions.responseHandlerVNext(response.data); //HelperFunctions.responseHandler(response.data);

      //if (_folderId === 0) {
      //  helper.designs = helper.designs.filter((row) => row.folderId == null);
      //};

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_FOLDERS,
        payload: helper,
      });
      return helper;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetAllFolders(
  clientId,
  folderId,
  allFolders,
  isTemplate = false
) {
  
  return async function (dispatch) {
    try {
      var _folderId = folderId ? folderId : 0;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetFolders?clientId=" +
        clientId +
        "&folderId=" +
        _folderId +
        "&allFolders=" +
        allFolders +
        "&isTemplate=" +
        isTemplate;

      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_FOLDERS_TREEVIEW,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllTrackingparams(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetTrackingParameters?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_TRACKING_PARAMS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAppendTrackingParameters(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetAppendTrackingParameter?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_APPEND_TRACKING_PARAMS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Pause(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/PauseDesign";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.PAUSE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Resume(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/ResumeEmail";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.RESUME,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
      
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function SaveAbandonCartSchedule(clientId, params) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SaveAbandonCartSchedule?clientId="+clientId;

      const response = await axios.post(URL, params);
   
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}


export function EnableAbandonCartEmail(params) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/EnableAbandonCartEmail";

      const response = await axios.post(URL, null,{
        params :{
          ReplyEmail : params.ReplyEmail,
          FromAddress : params.FromAddress,
          clientId : params.clientId,
          DesignId : params.DesignId
        }
      });
   
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Unpublish(clientId, designId, completed = false) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Unpublish";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
          completed: completed,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.UNPUBLISH,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Duplicate(
  clientId,
  designId,
  newDesignName,
  folderId,
  preserveSourceData = false
) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Duplicate";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
          newDesignName: newDesignName,
          folderId: folderId,
          preserveSourceData: preserveSourceData,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DUPLICATE,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function Move(clientId, designId, targetFolderId, isTemplate = false) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Move";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
          targetFolderId: targetFolderId,
          isTemplate: isTemplate
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.MOVE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function archive(clientId, folderId, parentId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Archive";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          folderId: folderId,
          parentId: parentId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.ARCHIVE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function rename(clientId, folderId, name, parentId, type) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/Rename";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          folderId: folderId,
          name: name,
          parentId: parentId,
          type: type
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.RENAME,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addFolder(clientId, param, folderId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/AddFolder";

      const response = await axios.post(URL, param, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.ADD_FOLDER,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function getSuppressionList(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.CONT_BASE_URL +
        "ESP/Email/GetSuppressionLists?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.SUPPRESION_LIST,
        payload: HelperFunctions.responseHandler(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAudienceCampaignList(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetCampaignsAndAudiences?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.AUDIENCE_CAMPAIGN_LIST,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function sendEmail(clientId, data) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SendEmail";
      const response = await axios.post(URL, data, {
        params: {
          clientId: clientId,
        },
      });
      // const response = await axios.post(
      //   Constants.CONT_BASE_URL + "ESP/Email/SendEmail",
      //   {
      //     emailViewModel: data,
      //   },
      //   {
      //     params: {
      //       clientId: clientId,
      //     },
      //   }
      // );

      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getFromEmailAddresses(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetFromEmailList?clientId=" +
        clientId;

      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);

      dispatch({
        type: EMAIL_DESIGNER.GET_FROM_ADDRESSES,
        payload: data,
      });
      // Return in middleware-transformed format so callers that capture the
      // return value get {label, value, IsDefault} — matching the Redux store.
      return (data || []).map((item) => ({
        label: item.fromEmailAddress,
        value: item.fromEmailAddress,
        IsDefault: item.isDefault,
      }));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

// export function GetDefaultValues(clientId) {
//   return async function (dispatch) {
//     try {
//       let URL =
//         Constants.VNEXT_BASE_URL +
//         "shared/GetDefaultValues?clientId=" +
//         clientId;

//       const response = await axios.get(URL);

//       dispatch({
//         type: EMAIL_DESIGNER.GET_DEFUALT_VALUES,
//         payload: HelperFunctions.responseHandlerVNext(response.data),
//       });
//     } catch (error) {
//       console.log("error", error.response);
//       console.log(typeof error);
//     }
//   };
// }

export function getReplyToEmailAddresses(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetReplyToEmailList?clientId=" +
        clientId;

      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);

      dispatch({
        type: EMAIL_DESIGNER.GET_REPLY_EMAIL_ADDRESSES,
        payload: data,
      });
      // Return in middleware-transformed format so callers that capture the
      // return value get {label, value, IsDefault} — matching the Redux store.
      return (data || []).map((item) => ({
        label: item.replyToEmailAddress,
        value: item.replyToEmailAddress,
        IsDefault: item.isDefault,
      }));
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getImageLibraryContents(clientId, path = "") {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetDirectoryContents?clientId=" +
        clientId +
        "&path=" +
        encodeURIComponent(path);
      let data = {};
      let folders = [];
      let images = [];
      const response = await axios.get(URL);
      var res = HelperFunctions.responseHandlerVNext(response.data);
      for (let index in res.directoryContents) {
        if (res.directoryContents[index].filePath) {
          res.directoryContents[index].fileType = res.directoryContents[
            index
          ].fileType
            .substr(1)
            .toUpperCase();
          res.directoryContents[index].fileAbsolutePath =
            Constants.VNEXT_BASE_URL +
            res.directoryContents[index].fileAbsolutePath +
            "?a=" +
            Math.random();
          images.push(res.directoryContents[index]);
        } else {
          folders.push(res.directoryContents[index]);
        }
      }
      data["Count"] = res.count;
      data["CurrentDirectoryPath"] = res.currentDirectoryPath;
      data["DefaultDirectoryPath"] = res.defaultDirectoryPath;
      data["LastModifiedDate"] = res.lastModifiedDate;
      data["Size"] = res.size;
      data["TopLevelDirectoryPath"] = res.topLevelDirectoryPath;
      data["folders"] = folders;
      data["images"] = images;

      dispatch({
        type: EMAIL_DESIGNER.GET_IMAGE_LIBRARY_CONTENTS,
        payload: data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function updateSelectedFolderName(payload) {
  return {
    type: EMAIL_DESIGNER.SELECTED_FOLDER_NAME,
    payload,
  };
}

export function AddDirectoryInLibrary(clientId, path, name) {
  return async function (dispatch) {
    try {
      var object = new Object();
      object.path = path;
      object.name = name;

      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/AddDirectory";

      const response = await axios.post(URL, object, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.ADD_DIRECTORY,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function UploadImage(clientId, path, files, overwrite) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        formData.append("file" + i, files[i]);
      }

      //formData.append('model', {Path: path, Overwrite: overwrite});
      //formData.append('overwrite', overwrite);
      // const config = {
      //   headers: {
      //     "content-type": "multipart/form-data",
      //   },
      // };
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Upload";
      // var payload = {
      //   Path: path,
      //   Overwrite: overwrite,
      // };
      const response = await axios.post(URL, formData, {
        params: {
          clientId: clientId,
          path: path,
          overwrite: overwrite,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.UPLOAD_IMAGE,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ValidateUpload(clientId, path, fileNames) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      formData.append("path", path);
      formData.append("fileNames", fileNames);
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/ValidateUpload";

      const response = await axios.post(URL, formData, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.VALIDATE_UPLOAD,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DeleteLibraryContent(
  clientId,
  param,
  isChildContentDelete = false
) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Delete";
      var object = new Object();
      object.paths = param;
      object.isChildContentDelete = isChildContentDelete;

      const response = await axios.post(URL, object, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_CONTENT,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function ReplaceImage(clientId, path, file, oldFileName) {
  return async function (dispatch) {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("path", path);
      formData.append("oldFileName", oldFileName);

      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Replace";

      const response = await axios.post(URL, formData, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.REPLACE_IMAGE,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error);
    }
  };
}

export function getReportOverViewEmailSummary(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetEmailSummary?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_OVERVIEW_EMAIL_SUMMARY,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getReportOverViewOpenAndClickRate(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetOpenAndClickRate?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_OVERVIEW_OPEN_AND_CLICK_RATE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getTopBottomPerformingSummary(
  clientId,
  performanceType,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetTopBottomPerformingSummary?clientId=${clientId}&performanceType=${performanceType}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.TOP_BOTTOM_PERFORMING_SUMMARY,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDesignCountByClientId(clientId, startDate, endDate) {
  return async function (dispatch) {
    try {
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetDesignsCountByClientId?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`;
      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DESIGN_COUNT_BY_CLIENT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDesignsByClientId(clientId, startDate, endDate) {
  return async function (dispatch) {
    try {
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetDesignDropdownByClientId?clientId=${clientId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DESIGN_DROPDOWN_BY_CLIENT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetEmailDetail(clientId, templateId) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetEmailDetail?clientId=${clientId}&templateId=${templateId}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DESIGN_EMAIL_DETAIL,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSubscriberTopLinks(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetSubscriberTopLinks?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_SUBSCRIBER_TOP_LINKS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSubscriberMostOpens(
  clientId,
  templateId,
  startDate,
  endDate
) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      startDate = startDate === null ? "" : startDate;
      endDate = endDate === null ? "" : endDate;
      const URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetSubscriberMostOpens?clientId=${clientId}&templateId=${templateId}&startDate=${startDate}&endDate=${endDate}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_SUBSCRIBER_MOST_OPENS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSubscribersDetails(clientId, templateId) {
  return async function (dispatch) {
    try {
      templateId = templateId === null ? "" : templateId;
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Overview/GetSubscribersDetails?clientId=${clientId}&templateId=${templateId}`;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.SUBSCRIBERS_DETAILS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

//export function saveTouchPointsForMapping(
//  clientId,
//  designId,
//  playTouchPointId
//) {
//  return async function (dispatch) {
//    try {
//      let URL =
//        Constants.VNEXT_BASE_URL + "ESP/Design/SaveTouchPointsForMapping";

//      const response = await axios.post(URL, null, {
//        params: {
//          clientId: clientId,
//          designId: designId,
//          playTouchPointId: playTouchPointId,
//        },
//      });

//      dispatch({
//        type: EMAIL_DESIGNER.SAVE_TOUCHPOINT_MAPPING,
//        payload: HelperFunctions.responseHandlerVNext(response.data),
//      });
//    } catch (error) {
//      console.log("error", error.response);
//      console.log(typeof error);
//    }
//  };
//}

export function GetImageLibraryFolders(clientId, path = "") {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetFolders?clientId=" +
        clientId +
        "&path=" +
        encodeURIComponent(path);

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_IMAGE_LIBRARY_FOLDERS_TREEVIEW,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetExternalImages(
  clientId,
  providerId,
  searchText,
  categories,
  pageNumber = 1,
  pageSize = 10
) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetExternalImages?clientId=" +
        clientId +
        "&providerId=" +
        providerId +
        "&searchText=" +
        encodeURIComponent(searchText) +
        "&categories=" +
        categories +
        "&pageNumber=" +
        pageNumber +
        "&pageSize=" +
        pageSize;

      var processedResult = await axios.get(URL).then((result) => {
        var responseData = HelperFunctions.responseHandlerVNext(result.data);
        if (responseData && responseData.directoryContents) {
          const externalAxios = axios.create();
          responseData.directoryContents.map((item) => {
            externalAxios
              .head(item.filePath)
              .then(function (imageResponse) {
                item.size = imageResponse.headers["content-length"];
              })
              .catch(function (error) {
                console.log("error: ", error);
                item.size = 0;
              });
          });
        }
        return responseData;
      });
      emptyExternalImages(null);
      dispatch({
        type: EMAIL_DESIGNER.GET_EXTERNAL_IMAGES,
        payload: processedResult,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

// export async function getContentLength(url) {
//   if(url) {
//     try {
//       console.log("URL: ",url);
//       const response = await axios.head(url);
//       console.log("response:", response);
//       console.log('in getContentLength ', response, response.headers, response.headers["Content-Length"]);

//       return response.headers["Content-Length"];

//     }
//     catch (error) {
//       console.log("error: ", error);
//         console.log("error", error.response);
//     }
//   }
//       return 0;
// }

export function emptyExternalImages(payload) {
  return {
    type: EMAIL_DESIGNER.GET_EXTERNAL_IMAGES,
    payload,
  };
}

export function emptyImageLibraryContents(payload) {
  return {
    type: EMAIL_DESIGNER.EMAIL_DESIGNER.GET_IMAGE_LIBRARY_CONTENTS,
    payload,
  };
}

export function emptyExternalCategories(payload) {
  return {
    type: EMAIL_DESIGNER.GET_EXTERNAL_CATEGORIES,
    payload,
  };
}

export function GetExternalCategories(clientId, providerId, searchText) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Image/GetExternalCategories?clientId=" +
        clientId +
        "&providerId=" +
        providerId +
        "&searchText=" +
        encodeURIComponent(searchText);

      const response = await axios.get(URL);
      const responseData = HelperFunctions.responseHandlerVNext(response.data);

      dispatch({
        type: EMAIL_DESIGNER.GET_EXTERNAL_CATEGORIES,
        payload: responseData,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function saveSchedule(clientId, scheduleTriggerId, data) {
  return async function (dispatch) {
    try {
      const response = await axios.post(
        Constants.VNEXT_BASE_URL + "ESP/Email/SaveSchedule",
        {
          sendNow: data.SendNow,
          isScheduleSend: data.IsScheduleSend,
          scheduleDateTime: data.ScheduleDateTime,
          scheduleTimeZone: data.ScheduleTimeZone,
          scheduleRecurring: data.ScheduleRecurring,
          scheduleRecurrence: data.ScheduleRecurrence,
          scheduleDayOfMonth: data.ScheduleDayOfMonth,
          scheduleDaysOfWeek: data.ScheduleDaysOfWeek,
          scheduleEndDate: data.ScheduleEndDate,
          runAfterCDPSnapshot: data.RunAfterCDPSnapshot,
        },
        {
          params: {
            clientId: clientId,
            scheduleTriggerId: scheduleTriggerId,
          },
        }
      );

      dispatch({
        type: EMAIL_DESIGNER.SAVE_SCHEDULE,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getScheduleTriggerById(clientId, scheduleTriggerId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetScheduleTriggerById?clientId=" +
        clientId +
        "&scheduleTriggerId=" +
        scheduleTriggerId;

      const response = await axios.get(URL);

      const data = HelperFunctions.responseHandlerVNext(response.data);
      if (data) {
        const offset = Moment().utcOffset();
        if (data.startDate) {
          console.log(data.startDate);
          data.startDate = new Moment(data.startDate).utcOffset(offset).format();
          console.log(data.startDate);
        }
        if (data.endDate) {
          console.log(data.endDate);
          data.endDate = new Moment(data.endDate).utcOffset(offset).format();
          console.log(data.endDate);
        }
      }

      dispatch({
        type: EMAIL_DESIGNER.SCHEDULE_TRIGGERS,
        payload: data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.DESIGN_BREADCRUMBS_ADD,
    payload,
  };
}

export function removeFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.DESIGN_BREADCRUMBS_REMOVE,
    payload,
  };
}
export function addTemplateFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_ADD,
    payload,
  };
}

export function removeTemplateFolderBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_REMOVE,
    payload,
  };
}
export function removeAllTemplateFolderBreadcrumbsAfterIndex(payload) {
  return {
    type: EMAIL_DESIGNER.TEMPLATE_BREADCRUMBS_REMOVE_ALL,
    payload,
  };
}

export function getMergeTags(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL + "ESP/Email/GetMergeTags?clientId=" + clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.BEE_MERGE_TAGS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function ToggleBeeReloadState(state) {
  return async function (dispatch) {
    try {
  
      dispatch({
        type: EMAIL_DESIGNER.RELOAD_BEE_EDITOR,
        payload: state
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function moveImages(clientId, paths, currentDirectory, selectedFolder) {
  return async function (dispatch) {
    try {
      var object = new Object();
      object.paths = paths;
      object.currentDirectoryPath = currentDirectory;
      object.selectedFolderPath = selectedFolder;
      let URL = Constants.VNEXT_BASE_URL + "ESP/Image/Move";

      const response = await axios.post(URL, object, {
        params: {
          clientId: clientId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.MOVE_IMAGES,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function addImageLibraryBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.IMAGE_BREADCRUMBS_ADD,
    payload,
  };
}

export function removeImageLibraryBreadcrumb(payload) {
  return {
    type: EMAIL_DESIGNER.IMAGE_BREADCRUMBS_REMOVE,
    payload,
  };
}
// A brandId fetches that brand's font list; omitting it fetches the client's default brand. Both
// land in clientFonts, which is correct for the consumers of this action: each of them (editor, form
// builder, survey builder) is looking at one brand at a time. Brand Settings uses getColorsFonts.
export function getCustomFonts(clientId, brandId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetCustomFonts?clientId=" +
        clientId +
        (brandId ? "&brandId=" + encodeURIComponent(brandId) : "");

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.CLIENT_FONTS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      // Land an empty list rather than nothing: the editor waits for this slice to stop being
      // undefined before it starts, so a failed fetch would otherwise hang on a blank canvas.
      dispatch({ type: EMAIL_DESIGNER.CLIENT_FONTS, payload: [] });
    }
  };
}

/** See getCustomFonts for why a brand-scoped response still lands in the client-level slice. */
export function getCustomColors(clientId, brandId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetCustomColors?clientId=" +
        clientId +
        (brandId ? "&brandId=" + encodeURIComponent(brandId) : "");

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.CLIENT_COLORS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      // See getCustomFonts: an empty palette still lets the editor start.
      dispatch({ type: EMAIL_DESIGNER.CLIENT_COLORS, payload: [] });
    }
  };
}

// Without a brandId this fetches the client's default brand and lands in clientContentDefaults —
// the slice the email editor, form builder and survey builder all read. A brand-scoped fetch is
// stored under brandContentDefaults[brandId] instead, so browsing a non-default brand in Brand
// Settings can't leave that brand's payload where those consumers will pick it up.
export function getContentDefaults(clientId, brandId) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetContentDefaults?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      const response = await axios.get(URL);
      const payload = HelperFunctions.responseHandlerVNext(response.data);
      if (brandId) {
        dispatch({ type: EMAIL_DESIGNER.BRAND_CONTENT_DEFAULTS, brandId, payload });
      } else {
        dispatch({ type: EMAIL_DESIGNER.CLIENT_CONTENT_DEFAULTS, payload });
      }
      return payload;
    } catch (error) {
      console.log("error", error.response);
      // Same reason as getCustomFonts and getCustomColors: the editor will not start until this
      // slice stops being undefined, so a failed fetch has to land something or the canvas stays
      // blank with no error and no retry. null means "fetched, none set", which the editor handles.
      if (brandId) {
        dispatch({ type: EMAIL_DESIGNER.BRAND_CONTENT_DEFAULTS, brandId, payload: null });
      } else {
        dispatch({ type: EMAIL_DESIGNER.CLIENT_CONTENT_DEFAULTS, payload: null });
      }
      return null;
    }
  };
}

export function saveContentDefaults(clientId, payload, brandId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SaveContentDefaults?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      const response = await axios.post(URL, payload);
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function getAiTrainingHub(clientId, brandId) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetAiTrainingHub?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.CLIENT_AI_TRAINING_HUB,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function saveAiTrainingHub(clientId, payload, brandId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SaveAiTrainingHub?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      const response = await axios.post(URL, payload);
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

// ─── Multi-Brand registry (Feature 73469) ───
// Returns null when the fetch failed (a throw, or OperationSuccessful = false) and an array when it
// succeeded, so callers can tell a failure from a client that genuinely has no brands. The shared
// response handler collapses both to [], and treating a failure as "no brands" empties the brand
// switcher behind a reassuring zero-state and leaves no active brand for a subsequent save to
// target. Callers that only need a list can still coerce with `|| []`.
export function getBrands(clientId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetBrands?clientId=" + clientId;
      const response = await axios.get(URL);
      if (response?.data?.operationSuccessful !== true) return null;
      return response.data.content || [];
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

export function createBrand(clientId, payload) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/CreateBrand?clientId=" + clientId;
      const response = await axios.post(URL, payload);
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function renameBrand(clientId, payload) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/RenameBrand?clientId=" + clientId;
      const response = await axios.post(URL, payload);
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function setDefaultBrand(clientId, payload) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SetDefaultBrand?clientId=" + clientId;
      const response = await axios.post(URL, payload);
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function deleteBrand(clientId, payload) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/DeleteBrand?clientId=" + clientId;
      const response = await axios.post(URL, payload);
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

// Per-brand Sender Identity selection + client-level pools (Feature 73469).
export function getSenderIdentity(clientId, brandId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetSenderIdentity?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      const response = await axios.get(URL);
      // Null means the read failed; an object (possibly empty) means it succeeded. Deliberately not
      // responseHandlerVNext, which returns [] for a failure and so made a failed read
      // indistinguishable from a brand with no identity - callers then told the user the brand was
      // unconfigured and sent them to fix something that was fine.
      if (response?.data?.operationSuccessful !== true) return null;
      return response.data.content ?? {};
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

// ─── Design-to-brand association (Feature 74422) ───

/**
 * The design's brand, already resolved server-side to the client's default brand when the design
 * carries none. Null only when the client has no brands at all, or the read failed.
 */
export function getDesignBrand(clientId, designId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetDesignBrand?clientId=" + clientId + "&designId=" + designId;
      const response = await axios.get(URL);
      if (response?.data?.operationSuccessful !== true) return null;
      return response.data.content || null;
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

/** Every design-to-brand association for the client, plus the default brand, in one call. */
export function getDesignBrands(clientId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetDesignBrands?clientId=" + clientId;
      const response = await axios.get(URL);
      if (response?.data?.operationSuccessful !== true) return null;
      return response.data.content || null;
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

/** Assigns a design to a brand. Returns true only on a confirmed write. */
export function setDesignBrand(clientId, designId, brandId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SetDesignBrand?clientId=" + clientId;
      const response = await axios.post(URL, { designId, brandId }, { suppressToast: true });
      return response?.data?.operationSuccessful === true;
    } catch (error) {
      console.log("error", error.response);
      return false;
    }
  };
}

export function saveSenderIdentity(clientId, payload, brandId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SaveSenderIdentity?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      const response = await axios.post(URL, payload, { suppressToast: true });
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function getSenderPools(clientId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetSenderPools?clientId=" + clientId;
      const response = await axios.get(URL);
      // null on failure rather than responseHandlerVNext's empty array, which callers could not tell
      // from a client with no sending addresses. The From step said a brand's address "is not
      // available to send from on this account" when it had simply failed to read the account.
      if (response?.data?.operationSuccessful !== true) return null;
      return response.data.content || null;
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

// Per-brand Colors & Fonts blob (Feature 73469, non-default brands).
export function getColorsFonts(clientId, brandId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/GetColorsFonts?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      const response = await axios.get(URL);
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

export function saveColorsFonts(clientId, payload, brandId) {
  return async function () {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/SaveColorsFonts?clientId=" + clientId + (brandId ? "&brandId=" + brandId : "");
      // Suppress the interceptor's generic "Operation Successful" toast; the caller shows
      // its own "Brand settings saved successfully" message.
      const response = await axios.post(URL, payload, { suppressToast: true });
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function UpdateCustomColors(clientId, payload) {
  return async function (dispatch) {
    try {
      const URL = Constants.VNEXT_BASE_URL + "ESP/Bee/UpdateCustomColors?clientId=" + clientId;

      const response = await axios.post(URL, payload);
      // Optional: handle success
      return response.data;

    } catch (error) {
      console.log("error", error.response);
    }
  };
}


export function getScheduleTriggerByEmailTemplateId(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Design/GetScheduleTriggerByEmailTemplateId?clientId=" +
        clientId +
        "&designId=" +
        designId;

      const response = await axios.get(URL);

      const payload = HelperFunctions.responseHandlerVNext(response.data);
      // Tagged with the design it describes. This lands in global redux that is never cleared and is
      // written by every screen that opens a mapping, so a consumer reading it after mounting for a
      // DIFFERENT design would otherwise hydrate the previous design's trigger without any way to
      // tell. The server response carries no design identity, so it is stamped here.
      const tagged =
        payload && typeof payload === "object" && !Array.isArray(payload)
          ? { ...payload, forDesignId: designId }
          : payload;
      dispatch({
        type: EMAIL_DESIGNER.DESIGN_SCHEDULE_TRIGGER,
        payload: tagged,
      });
      return tagged;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DisableScheduleTrigger(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/DisableScheduleTrigger";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DISABLED_SCHEDULED,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function DisableEdit(clientId, designId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/DisableEdit";

      const response = await axios.post(URL, null, {
        params: {
          clientId: clientId,
          designId: designId,
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DISABLED_EDIT_SCHEDULED,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getSendsPageData(clientId, templateStatus, startDate, endDate) {
  return async function (dispatch) {
    try {
      startDate = startDate == null ? "" : startDate;
      endDate = endDate == null ? "" : endDate;
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetSends?clientId=" +
        clientId +
        "&templateStatus&startDate=" +
        startDate +
        "&endDate=" +
        endDate;

      if (templateStatus)
        URL =
          Constants.VNEXT_BASE_URL +
          "ESP/Email/GetSends?clientId=" +
          clientId +
          "&templateStatus=" +
          templateStatus +
          "&startDate=" +
          startDate +
          "&endDate=" +
          endDate;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.REPORT_SENDS_PAGE,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDynamicListData(clientId, fieldName, searchPattern) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetDynamicListData?clientId=" +
        clientId +
        "&fieldName=" +
        fieldName +
        "&searchPattern=";
      if (searchPattern != null && searchPattern !== "") {
        URL = URL + searchPattern;
      }
      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.DYNAMICFIELDS,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getDynamicContentFields(clientId) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Bee/GetDynamicEmailContentFields?clientId=" +
        clientId;

      const response = await axios.get(URL);

      dispatch({
        type: EMAIL_DESIGNER.DYNAMIC_CONTENT_FIELDS,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function ValidatePageScrapeUrl(url) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL
        }ESP/Bee/ValidatePageScrapeUrl?url=${encodeURIComponent(
          url
        )}`;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.EXTERNAL_URL_VALIDATION,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function AddRow(categoryId, name, rowJSON, clientId, templateId = null, versionId = null) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL + "ESP/Design/AddRow?clientId=" + clientId;
      let params = {
        SaveRowName: name,
        CategoryId: categoryId,
        SaveRowJSON: rowJSON,
        TemplateId: templateId,
        VersionId: versionId
      };
      const response = await axios({
        method: "post",
        url: URL,
        data: params,
      });
      const handledResponse = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.ON_SAVE_ROW,
        payload: handledResponse,
      });
      // Return the response so caller can get savedRowId
      return handledResponse;
    } catch (error) {
      console.log("error", error.response);
      return null;
    }
  };
}

export function GetSavedRowsCategories(clientId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetSavedRowsCategories?clientId=${clientId}`;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.SAVED_ROWS_CATEGORIES,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetSavedRowsByCategoryId(clientId, categoryId, designId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetSavedRowsByCategoryId?clientId=${clientId}&categoryId=${categoryId}&designId=${designId}`;
      const response = await axios.get(URL);
      const data = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SAVED_ROWS,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function AddRowValidations(clientId, categoryId, rowName) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL
        }ESP/Design/AddRowValidations?clientId=${clientId}&categoryId=${categoryId}&rowName=${rowName}`;
      const response = await axios.get(URL);
      dispatch({
        type: EMAIL_DESIGNER.SAVE_ROW_VALIDATION,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function GetSavedRowById(clientId, savedRowId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/GetSavedRowById?clientId=${clientId}&savedRowId=${savedRowId}`;
      const response = await axios.get(URL);
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function UpdateRow(clientId, savedRowId, rowName, rowJSON, isSynced, templateId, versionId) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/UpdateRow?clientId=${clientId}`;
      let params = {
        SaveRowId: savedRowId,
        SaveRowName: rowName,
        SaveRowJSON: rowJSON,
        IsSynced: isSynced,
        TemplateId: templateId,
        VersionId: versionId,
      };
      const response = await axios({
        method: "post",
        url: URL,
        data: params,
      });
      return HelperFunctions.responseHandlerVNext(response.data);
    } catch (error) {
      console.log("error", error.response);
      throw error;
    }
  };
}

export function DeleteSavedRow(clientId, savedRowId, isPreferenceCenterSavedRow = false) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Design/DeleteSavedRow";

      const response = await axios.delete(URL, {
        params: {
          clientId: clientId,
          savedRowId: savedRowId,
          isPreferenceCenterSavedRow: isPreferenceCenterSavedRow
        },
      });

      dispatch({
        type: EMAIL_DESIGNER.DELETE_SAVED_ROW,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postEmailSendToDetails(sendToVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateSendTo?clientId=${sendToVM.ClientId}`;
      const response = await axios.post(URL, sendToVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL_SEND_TO,
        payload: responseModel
      });
      return responseModel;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postEmailFromDetails(fromVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateFrom?clientId=${fromVM.ClientId}`;
      const response = await axios.post(URL, fromVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL_FROM,
        payload: responseModel
      });
      return responseModel;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postPropertiesDetails(propertiesVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateProperties?clientId=${propertiesVM.ClientId}`;
      const response = await axios.post(URL, propertiesVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL_PROPERTIES,
        payload: responseModel
      });
      return responseModel;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postScheduleDetails(scheduleVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateSchedule?clientId=${scheduleVM.ClientId}`;
      const response = await axios.post(URL, scheduleVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.DESIGN_SCHEDULE_TRIGGER,
        payload: responseModel
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function postWebhookTriggerDetails(scheduleVM) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/SaveUpdateWebhookTrigger?clientId=${scheduleVM.ClientId}`;
      const response = await axios.post(URL, scheduleVM);
      var responseModel = HelperFunctions.responseHandlerVNext(response.data);
      dispatch({
        type: EMAIL_DESIGNER.DESIGN_WEBHOOK_TRIGGER,
        payload: responseModel
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export const getEspUserCredit = (clientId) => async (dispatch) => {
  try {
    const URL = `${(import.meta.env.VITE_VNEXT_BASE_URL + import.meta.env.VITE_VNEXT_API)}ESP/Email/GetESPUserCredit?clientId=${clientId}`;
    const response = await axios.get(URL);
    if (response.data.operationSuccessful) {
      dispatch({
        type: EMAIL_DESIGNER.SET_ESP_USER_CREDIT,
        payload: HelperFunctions.responseHandlerVNext(response.data),
      });
    }
  } catch (error) {
    console.log("error", error.response);
    console.log(typeof error);
  }
};

export function listSendFileValidation(clientId, templateId, fieldName, file, recipientColumn, originalRowCount, duplicatesRemoved) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + `ESP/Email/ValidateListSend?clientId=${clientId}&templateId=${templateId}&recipientColumn=${encodeURIComponent(recipientColumn)}&originalRowCount=${originalRowCount || 0}&duplicatesRemoved=${duplicatesRemoved || 0}`;
      let formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      dispatch({
        type: EMAIL_DESIGNER.LIST_SEND_FILE_VALIDATION,
        payload: response.data
      });
      return response.data;
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function resetListSendFileValidation() {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.LIST_SEND_FILE_VALIDATION,
        payload: null
      });
    } catch (error) {
      console.log("error", error);
      return error;
    }
  };
}

export function sendEmailListSend(clientId, data, columnMappings, respectCDPPermissions, recipientColumnName, processedFilePath) {
  return async function (dispatch) {
    try {
      // Validate that processedFilePath is provided
      if (!processedFilePath) {
        console.error('ProcessedFilePath is required for sendEmailListSend');
        dispatch({
          type: EMAIL_DESIGNER.SEND_EMAIL,
          payload: {
            operationSuccessful: false,
            messages: [{
              messageTypeId: 2,
              messageContent: 'ProcessedFilePath is required. Please validate the file first.'
            }]
          }
        });
        return;
      }

      let formData = new FormData();
      // Add other data fields to the FormData object
      Object.keys(data).forEach((key) => {
        if (data[key] && key !== "TrackingParamsList") {
          formData.append(key, data[key]);
        }
      });

      // Add the processed file path from validation (required)
      formData.append('processedFilePath', processedFilePath);

      // Add mapping and permissions data
      if (columnMappings) {
        formData.append('columnMappings', JSON.stringify(columnMappings));
      }
      formData.append('respectCDPPermissions', respectCDPPermissions);
      if (recipientColumnName) {
        formData.append('recipientColumnName', recipientColumnName);
      }

      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/SendEmailListSend?clientId=" + clientId;

      const response = await axios.post(URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      dispatch({
        type: EMAIL_DESIGNER.SEND_EMAIL,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function enableWebhookTriggerEmail(clientId, data, DataConfigId) {
  return async function (dispatch) {
    try {
      let formData = new FormData();
      // Add other data fields to the FormData object
      Object.keys(data).forEach((key) => {
        if (data[key] && key !== "TrackingParamsList") {
          formData.append(key, data[key]);
        }
      });
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/EnableWebhookTriggerEmail?clientId=" + clientId + "&DataConfigID=" + DataConfigId;
      const response = await axios.post(URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      dispatch({
        type: EMAIL_DESIGNER.ENABLE_WEBHOOK_TRIGGER,
        payload: response.data,
      });
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getWebhookUrl(clientId, dataConfigId, webhookID) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/GetWebhookUrl?clientId=" +
        clientId + "&dataConfigId=" + dataConfigId + "&webhookID=" + webhookID;

      const response = await axios.get(URL);
      const test = "";
      dispatch({
        type: EMAIL_DESIGNER.GET_WEBHOOK_URL,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function updateWebHookStatus(clientId, webhookDataID, status) {
  return async function (dispatch) {
    try {
      let URL =
        Constants.VNEXT_BASE_URL +
        "ESP/Email/UpdateWebhookDataStatus?clientId=" +
        clientId + "&webhookDataID=" + webhookDataID + "&status=" + status;

      const response = await axios.get(URL);
      response.data.content = response.data.operationSuccessful
      return response.data;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

// enforceStatusRule opts a caller into the Payload History resend rule (no Failed, no
// InProgress). Off by default because other surfaces deliberately allow resending a failed
// payload: Triggered Emails offers Resend on every row so the operator can correct the
// recipient and re-fire.
export function resendWebhookPayload(clientId, webhookDataId, webhookConfigId, recipientOverride = null, enforceStatusRule = false) {
  return async function (dispatch) {
    try {
      let URL = `${Constants.VNEXT_BASE_URL}ESP/Design/ResendWebhookPayload?clientId=${clientId}&webhookDataId=${webhookDataId}&webhookConfigId=${webhookConfigId}&enforceStatusRule=${enforceStatusRule}`;
      // recipientOverride (V2 inline email edit): send this triggered email to a corrected address
      // without mutating the original event.
      if (recipientOverride) URL += `&recipientOverride=${encodeURIComponent(recipientOverride)}`;
      // Suppress the global interceptor's toast — the endpoint's "Resend initiated" is HTTP-success,
      // not send-success (misleading), and the Triggered Emails UI shows state via the grid + strip.
      const response = await axios.post(URL, null, { suppressToast: true });
      return response.data;
    } catch (error) {
      console.log("error", error.response);
    }
  };
}

export function getEspUsers(clientId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + "ESP/Email/GetEspUsers?clientId=" + clientId; 

      const response = await axios.get(URL);
      return response.data.content;
    } catch (error) {
      console.log("error", error.response);
      console.log(typeof error);
    }
  };
}

export function getAllMergeTagsFromDesign(clientId, templateId) {
  return async function (dispatch) {
    try {
      let URL = Constants.VNEXT_BASE_URL + 'ESP/Email/GetAllMergeTagsFromDesign?clientId=' + clientId + "&templateId=" + templateId;

      const response = await axios.get(URL);
      // const responseData = HelperFunctions.responseHandlerVNext(response.data);
      const responseData = response.data;
      dispatch({
        type: EMAIL_DESIGNER.GET_ALL_MERGE_TAGS_FROM_DESIGN,
        payload: responseData
      });
      return responseData;
    } catch (error) {
      console.log("error", error);
    }
  };
}


export function getDesignPreview(partitionKey) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW,
        payload: { loading: true, error: false }
      });

      const URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/GetDesignPreview/${partitionKey}`;
      const response = await axios.get(URL);
      const result = HelperFunctions.responseHandlerVNext(response.data);

      if(result?.length === 0){
        dispatch({
          type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW_ERROR,
          payload: { loading: false, error: true }
        });
        return;
      }

      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW_SUCCESS,
        payload: {
          designName: result.designName,
          beeAuthResponse: result.beeAuthResponse,
          json: result.json,
          html: result.html,
          loading: false,
          error: false
        }
      });

      return result;
    } catch (error) {
      console.error("getDesignPreview error:", error);
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_PREVIEW_ERROR,
        payload: { loading: false, error: true }
      });
      throw error;
    }
  };
}

export function getDesignIdByPartitionKey(partitionKey) {
  return async function (dispatch) {
    try {
      const URL = `${Constants.VNEXT_BASE_URL}/ESP/Bee/GetDesignIdByPartitionKey/${partitionKey}`;
      const response = await axios.get(URL);
      
      dispatch({
        type: EMAIL_DESIGNER.GET_DESIGN_ID_BY_PARTITION,
        payload: response.data
      });

      return response.data;
    } catch (error) {
      console.error("getDesignIdByPartitionKey error:", error);
      throw error;
    }
  };
}

export function generatePublicPreviewLink(clientId, designId) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK,
        payload: { isGeneratingLink: true }
      });

      const response = await axios.post(
        `${import.meta.env.VITE_VNEXT_BASE_URL}api/ESP/Bee/GeneratePublicPreviewLink`,
        {
          clientId: clientId,
          designId: designId
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      
      const result = response.data;
      
      if (result.operationSuccessful) {
        const publicPreviewLink = `${import.meta.env.VITE_BASE_URL}${result.content}`;
        dispatch({
          type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { 
            publicPreviewLink,
            isGeneratingLink: false 
          }
        });
        return { success: true, link: publicPreviewLink };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_ERROR,
          payload: { isGeneratingLink: false, error: "Failed to generate preview link" }
        });
        return { success: false, error: "Failed to generate preview link" };
      }
    } catch (error) {
      console.error("Error generating preview link:", error);
      dispatch({
        type: EMAIL_DESIGNER.GENERATE_PUBLIC_PREVIEW_LINK_ERROR,
        payload: { isGeneratingLink: false, error: "Failed to generate preview link" }
      });
      return { success: false, error: "Failed to generate preview link" };
    }
  };
}

export function revokePublicPreviewLink(clientId, designId) {
  return async function (dispatch) {
    try {
      dispatch({
        type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK,
        payload: { isRevokingLink: true }
      });

      const response = await axios.post(
        `${import.meta.env.VITE_VNEXT_BASE_URL}api/ESP/Bee/RevokePublicPreviewLink`,
        {
          clientId: clientId,
          designId: designId
        },
        {
          headers: {
            'Content-Type': 'application/json',
          }
        }
      );
      
      const result = response.data;
      
      if (result.operationSuccessful) {
        dispatch({
          type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { 
            publicPreviewLink: "",
            isRevokingLink: false,
            showRevokeConfirm: false
          }
        });
        return { success: true, message: "Preview link revoked successfully" };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_ERROR,
          payload: { 
            isRevokingLink: false,
            showRevokeConfirm: false,
            error: "Failed to revoke preview link"
          }
        });
        return { success: false, error: "Failed to revoke preview link" };
      }
    } catch (error) {
      console.error("Error revoking preview link:", error);
      dispatch({
        type: EMAIL_DESIGNER.REVOKE_PUBLIC_PREVIEW_LINK_ERROR,
        payload: { 
          isRevokingLink: false,
          showRevokeConfirm: false,
          error: "Failed to revoke preview link"
        }
      });
      return { success: false, error: "Failed to revoke preview link" };
    }
  };
}

export function getPublicPreviewLink(clientId, designId) {
  return async function (dispatch) {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_VNEXT_BASE_URL}api/ESP/Bee/GetPublicPreviewLink`,
        {
          params: {
            clientId: clientId,
            designId: designId
          }
        }
      );
      
      const result = response.data;
      
      if (result.operationSuccessful && result.content) {
        const publicPreviewLink = `${import.meta.env.VITE_BASE_URL}${result.content}`;
        dispatch({
          type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { publicPreviewLink }
        });
        return { success: true, link: publicPreviewLink };
      } else {
        dispatch({
          type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { publicPreviewLink: "" }
        });
        return { success: true, link: "" };
      }
    } catch (error) {
      // A 400 means the design has no preview link yet — treat as "no link" rather than a true error
      if (error?.response?.status === 400) {
        dispatch({
          type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_SUCCESS,
          payload: { publicPreviewLink: "" }
        });
        return { success: true, link: "" };
      }
      console.error("Error checking existing preview link:", error);
      dispatch({
        type: EMAIL_DESIGNER.GET_PUBLIC_PREVIEW_LINK_ERROR,
        payload: { publicPreviewLink: "", error: "Failed to get preview link" }
      });
      return { success: false, error: "Failed to get preview link" };
    }
  };
}

export function clearPublicPreviewLink() {
  return {
    type: EMAIL_DESIGNER.CLEAR_PUBLIC_PREVIEW_LINK,
    payload: {
      publicPreviewLink: "",
      isGeneratingLink: false,
      isRevokingLink: false,
      showRevokeConfirm: false
    }
  };
}

export function clearDesignPreview() {
  return {
    type: EMAIL_DESIGNER.CLEAR_DESIGN_PREVIEW,
    payload: null
  };
}

export function ExportEmailDesignHtml(clientId, designId, designName) {
  return async function () {
    try {
      const url = `${Constants.VNEXT_BASE_URL}ESP/Design/ExportHtml?clientId=${clientId}&designId=${designId}`;

      const timestamp = new Date()
        .toISOString()
        .replace(/[-:T]/g, (c) => (c === "T" ? "-" : c === ":" ? "" : c))
        .slice(0, 15);
      const sanitizedName = (designName || "design")
        .replace(/[^a-zA-Z0-9\s-]/g, "")
        .trim()
        .replace(/\s+/g, "-")
        .toLowerCase();
      const fileName = `${sanitizedName}-${timestamp}.html`;

      await downloadFileV2(url, fileName);
      return { success: true };
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to export HTML.";
      return { success: false, error: message };
    }
  };
}


/**
 * Runs Bee Check against a template JSON to identify design issues.
 * Calls the backend API which proxies to Bee Content Services API.
 * @param {string} templateJson - The template JSON string to check
 * @param {string} checkType - "message" for Email or "page" for Page/Landing Page
 * @returns {Function} Redux thunk action
 */
export function runBeeCheck(templateJson, checkType = "message") {
  return async function (dispatch) {
    try {
      dispatch({ type: EMAIL_DESIGNER.BEE_CHECK_REQUEST });

      const URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/CheckDesign`;

      const response = await axios({
        method: "post",
        url: URL,
        data: {
          templateJson: templateJson,
          checkType: checkType
        },
      });

      const result = response.data;

      if (result.operationSuccessful) {
        const checkResults = typeof result.content === "string"
          ? JSON.parse(result.content)
          : result.content;

        dispatch({
          type: EMAIL_DESIGNER.BEE_CHECK_SUCCESS,
          payload: checkResults,
        });

        return { success: true, data: checkResults };
      } else {
        const errorMsg = result.messages?.[0]?.messageContent || "Check failed";
        dispatch({
          type: EMAIL_DESIGNER.BEE_CHECK_ERROR,
          payload: errorMsg,
        });
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Bee Check error:", error);
      dispatch({
        type: EMAIL_DESIGNER.BEE_CHECK_ERROR,
        payload: error.message || "Failed to run design check",
      });
      return { success: false, error: error.message };
    }
  };
}

/**
 * Clears the Bee Check results from the store.
 */
export function clearBeeCheck() {
  return {
    type: EMAIL_DESIGNER.BEE_CHECK_CLEAR,
  };
}

/**
 * Applies the client's current Content Defaults to an existing email design JSON via
 * BEE's Brand Style Management endpoint (proxied through our backend). Block content
 * (text, image src, link href, etc.) is preserved by BEE; only block styling is overwritten.
 *
 * Backend already crafts the user-facing message — including the AC #9 "no matching blocks"
 * text for BEE's 422 response — so callers can surface `result.error` verbatim in a toast.
 *
 * @param {number} clientId
 * @param {string} templateJson - The current design JSON as a string (from latestTemplateJsonRef)
 * @returns {Promise<{success: boolean, templateJson?: object, error?: string}>}
 */
export async function applyBrandStyle(clientId, templateJson, brandId) {
  try {
    const URL = `${Constants.VNEXT_BASE_URL}ESP/Bee/ApplyBrandStyle?clientId=${clientId}${brandId ? `&brandId=${brandId}` : ""}`;
    const response = await axios.post(URL, { templateJson });
    const result = response.data;

    if (result.operationSuccessful) {
      const restyled = typeof result.content === "string"
        ? JSON.parse(result.content)
        : result.content;
      return { success: true, templateJson: restyled };
    }

    const errorMsg = result.messages?.[0]?.messageContent || "Failed to apply Content Defaults.";
    return { success: false, error: errorMsg };
  } catch (error) {
    console.error("Apply Brand Style error:", error);
    return { success: false, error: error.message || "Failed to apply Content Defaults." };
  }
}
